// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"92":"7dab59d9","387":"86af5fd4","468":"9219dff6","493":"fd1c81ad","619":"e28abf43","624":"a8f2cc4c","649":"40f65c13","671":"3ade037a","794":"3698b5c8","922":"14341f31","940":"e5332604"}[chunkId] + ".chunk.js";
};